export default function HashtagList({
  list,
  selectedHashtag,
  setSelectedHashtag,
  firstCurrentPage,
}) {
  return (
    <div className="hashtag-container py-2 my-2">
      <div
        className={`mx-1 my-2 p-2 d-flex align-items-center justify-content-center ${
          selectedHashtag == -1 ? "active-hashtag-btn" : "deactive-hashtag-btn"
        }`}
        onClick={() => {
          setSelectedHashtag(-1);
          firstCurrentPage();
        }}
      >
        همه
      </div>
      {list?.map((value) => {
        return (
          <div
            className={`mx-1 my-2 p-2 d-flex align-items-center justify-content-center ${
              selectedHashtag == value.id
                ? "active-hashtag-btn"
                : "deactive-hashtag-btn"
            }`}
            onClick={() => {
              setSelectedHashtag(value.id);
              firstCurrentPage();
            }}
          >
            {value.txt}
          </div>
        );
      })}
    </div>
  );
}
